export const REBOUND_DURATION = 600
export const MINIMUM_CHARS_SEARCH = 2
